import React, { useState } from 'react';
import {
  Button,
  Divider,
  Group,
  Paper,
  PasswordInput,
  SimpleGrid,
  Title,
} from '@mantine/core';
import { authAPI } from '../services/api.ts';
import { toast } from '../lib/toast.ts';

export const UpdatePassword: React.FC = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate passwords
    if (newPassword !== confirmPassword) {
      toast.error('New passwords do not match');
      return;
    }

    if (newPassword.length < 8) {
      toast.error('New password must be at least 8 characters long');
      return;
    }

    try {
      setIsLoading(true);
      await authAPI.updatePassword(currentPassword, newPassword);
      toast.success('Password updated successfully');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Paper withBorder shadow="sm" p={{ base: 'md', sm: 'lg' }}>
      <Title order={4} mb="md">
        Update Password
      </Title>

      <form onSubmit={handleSubmit}>
        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="lg">
          <PasswordInput
            id="currentPassword"
            label="Current Password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.currentTarget.value)}
            visible={showCurrentPassword}
            onVisibilityChange={setShowCurrentPassword}
            required
          />
          <PasswordInput
            id="newPassword"
            label="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.currentTarget.value)}
            visible={showNewPassword}
            onVisibilityChange={setShowNewPassword}
            required
          />
          <PasswordInput
            id="confirmPassword"
            label="Confirm New Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.currentTarget.value)}
            visible={showConfirmPassword}
            onVisibilityChange={setShowConfirmPassword}
            required
          />
        </SimpleGrid>

        <Divider my="lg" />

        <Group justify="flex-end">
          <Button type="submit" loading={isLoading}>
            Update Password
          </Button>
        </Group>
      </form>
    </Paper>
  );
};
